import { render, staticRenderFns } from "./waterFall.module.vue?vue&type=template&id=5bec1134&scoped=true"
import script from "./waterFall.module.vue?vue&type=script&lang=js"
export * from "./waterFall.module.vue?vue&type=script&lang=js"
import style0 from "./waterFall.module.vue?vue&type=style&index=0&id=5bec1134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bec1134",
  null
  
)

export default component.exports